'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { useControllableReducer } from "../utils/useControllableReducer.js";
import { DropdownActionTypes } from "./useDropdown.types.js";
import { dropdownReducer } from "./dropdownReducer.js";
/**
 *
 * Demos:
 *
 * - [Menu](https://mui.com/base-ui/react-menu/#hooks)
 *
 * API:
 *
 * - [useDropdown API](https://mui.com/base-ui/react-menu/hooks-api/#use-dropdown)
 */ export function useDropdown() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var defaultOpen = parameters.defaultOpen, onOpenChange = parameters.onOpenChange, openProp = parameters.open, _parameters_componentName = parameters.componentName, componentName = _parameters_componentName === void 0 ? 'useDropdown' : _parameters_componentName;
    var _React_useState = _sliced_to_array(React.useState(''), 2), popupId = _React_useState[0], setPopupId = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), triggerElement = _React_useState1[0], setTriggerElement = _React_useState1[1];
    var lastActionType = React.useRef(null);
    var handleStateChange = React.useCallback(function(event, field, value, reason) {
        if (field === 'open') {
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(event, value);
        }
        lastActionType.current = reason;
    }, [
        onOpenChange
    ]);
    var controlledProps = React.useMemo(function() {
        return openProp !== undefined ? {
            open: openProp
        } : {};
    }, [
        openProp
    ]);
    var _useControllableReducer = _sliced_to_array(useControllableReducer({
        controlledProps: controlledProps,
        initialState: defaultOpen ? {
            open: true,
            changeReason: null
        } : {
            open: false,
            changeReason: null
        },
        onStateChange: handleStateChange,
        reducer: dropdownReducer,
        componentName: componentName
    }), 2), state = _useControllableReducer[0], dispatch = _useControllableReducer[1];
    React.useEffect(function() {
        if (!state.open && lastActionType.current !== null && lastActionType.current !== DropdownActionTypes.blur) {
            triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.focus();
        }
    }, [
        state.open,
        triggerElement
    ]);
    var contextValue = {
        state: state,
        dispatch: dispatch,
        popupId: popupId,
        registerPopup: setPopupId,
        registerTrigger: setTriggerElement,
        triggerElement: triggerElement
    };
    return {
        contextValue: contextValue,
        open: state.open
    };
}
